import axios from "axios";

class FullyAPI {
  isFullyDevice = false;
  hideNavigationBarTimer: NodeJS.Timeout|undefined;

  fullyPassword = "12";

  constructor() {
    if ((window as any).fully) {
      this.isFullyDevice = true;

      (window as any).fully.bind('broadcastReceived',(action: any, extras: any) => {
        alert(action);
        alert(extras);
      });
    }
    
  }

  getMacAddress() {
    if (!this.isFullyDevice) return "test-mac";
    return (window as any).fully.getMacAddress();
  }

  getDeviceId() {
    if (!this.isFullyDevice) return "XXXXX";
    return (window as any).fully.getDeviceId().replace("-", "");
  }

  getIp4Address() {
    if (!this.isFullyDevice) return "0.0.0.0";
    return (window as any).fully.getIp4Address();    
  }

  getIp6Address() {
    if (!this.isFullyDevice) return "::1";
    return (window as any).fully.getIp6Address();    
  }

  getWifiSsid() {
    if (!this.isFullyDevice) return "no-wifi";
    return (window as any).fully.getWifiSsid();        
  }

  getWifiSignalLevel() {
    if (!this.isFullyDevice) return '0';
    return (window as any).fully.getWifiSignalLevel();        
  }

  getImei() {
    if (!this.isFullyDevice) return "";
    return (window as any).fully.getImei();
  }

  getSimSerialNumber() {
    if (!this.isFullyDevice) return "";
    return (window as any).fully.getSimSerialNumber();
  }

  openWifiSettings() {    
    if (!this.isFullyDevice) return false;
    (window as any).fully.openWifiSettings();
    this.showNavigationBar();
    return true
  }

  showNavigationBar() {
    if (!this.isFullyDevice) return;
    (window as any).fully.setBooleanSetting('knoxHideNavigationBar', false);
    this.startHideNavigationBarTimer();
  }

  hideNavigationBar() {
    if (!this.isFullyDevice) return;
    (window as any).fully.setBooleanSetting('knoxHideNavigationBar', true);
  }  

  startHideNavigationBarTimer() {
    if (this.hideNavigationBarTimer) return;

    this.hideNavigationBarTimer = setInterval(async () => {
      if (!this.hideNavigationBarTimer) return;
      const helperResponse = await axios.get("http://localhost:8765/pw/" + JSON.parse(localStorage.deviceConfig).salt);
      if (helperResponse.data.device_info) {
        const deviceInfo = JSON.parse(helperResponse.data.device_info);
        if (deviceInfo.foreground == "com.android.settings") return;
      }

      if (!(window as any).fully.isInForeground()) return;

      this.hideNavigationBar();
      clearInterval(this.hideNavigationBarTimer);
      this.hideNavigationBarTimer = undefined;
    }, 1000);
  }

  startTerminalHelperApp() {
    if (!this.isFullyDevice) return;
    (window as any).fully.startApplication("com.zeitstrom.terminalhelper");
    (window as any).fully.bringToForeground();
  }

  loadStart() {
    if (!this.isFullyDevice) {
      window.location.replace("/");
      return;
    }
    (window as any).fully.loadStartUrl();
  }

}



const fully = new FullyAPI();

export { fully }


/*

String fully.getCurrentLocale()
String fully.getIp4Address()
String fully.getIp6Address()
String fully.getHostname()
String fully.getHostname6()
String fully.getMacAddress()
String fully.getMacAddressForInterface(String interface)
String fully.getWifiSsid()
String fully.getWifiSignalLevel()  // ver. 1.30+
String fully.getSerialNumber()
String fully.getAndroidId()
String fully.getDeviceId()
String fully.getImei()
String fully.getSimSerialNumber()
float fully.getBatteryLevel()
float fully.getScreenBrightness()
int fully.getScreenOrientation() // ver. 1.40.2+
int fully.getDisplayWidth()
int fully.getDisplayHeight()
boolean fully.getScreenOn()
boolean fully.isPlugged()
boolean fully.isKeyboardVisible()
boolean fully.isWifiEnabled()
boolean fully.isBluetoothEnabled()
boolean fully.isScreenRotationLocked()  // ver. 1.40.2+
String fully.getFullyVersion()
int fully.getFullyVersionCode()
String fully.getWebviewVersion()
String fully.getAndroidVersion()
int fully.getAndroidSdk()
String fully.getDeviceModel()

// Get storage info (ver. 1.33+)
long fully.getInternalStorageTotalSpace()
long fully.getInternalStorageFreeSpace()
long fully.getExternalStorageTotalSpace()
long fully.getExternalStorageFreeSpace()

// Get environment sensor info (ver. 1.40+)
String fully.getSensorInfo()
float fully.getSensorValue(int type)
String fully.getSensorValues(int type)

*/